// // src/components/Class.js

// import React, { useState, useEffect } from "react";
// import axios from "axios"; // Убедитесь, что axios установлен: npm install axios
// import "../styles/Class.css";

// const Class = () => {
//     // Состояния для данных из API /items/klassen
//     const [klassen, setKlassen] = useState([]);
//     const [loadingKlassen, setLoadingKlassen] = useState(true);
//     const [errorKlassen, setErrorKlassen] = useState(null);

//     // URL вашего API
//     const KLASSEN_API_URL = process.env.REACT_APP_API_BASE_URL + '/items/Klassen?fields=*.*.*';

//     useEffect(() => {
//         const fetchKlassen = async () => {
//             try {
//                 const response = await axios.get(KLASSEN_API_URL);
//                 if (response.data && response.data.data) {
//                     setKlassen(response.data.data);
//                 } else {
//                     setErrorKlassen('Нет данных для отображения');
//                 }
//             } catch (error) {
//                 setErrorKlassen('Ошибка при получении данных');
//                 console.error(error);
//             } finally {
//                 setLoadingKlassen(false);
//             }
//         };

//         fetchKlassen();
//     }, []);

//     // Функция для формирования URL иконки
//     const getIconUrl = (icon) => {
//         if (!icon || !icon.filename_disk) return null;
//         // Поскольку доступ по /files/ возвращает 403, используем /assets/
//         const baseUrl = process.env.REACT_APP_API_BASE_URL + '/assets/';
//         return `${baseUrl}${icon.filename_disk}`;
//     };

//     // Функция для группировки классов по категориям
//     const groupByCategory = (klassen) => {
//         return klassen.reduce((acc, klasse) => {
//             const categoryName = klasse.Kategorie?.Name || "Без категории";
//             if (!acc[categoryName]) {
//                 acc[categoryName] = [];
//             }
//             acc[categoryName].push(klasse);
//             return acc;
//         }, {});
//     };

//     // Сгруппированные данные
//     const groupedKlassen = groupByCategory(klassen);

//     return (
//         <div className="class">
//             <h1 className="title">
//                 Hier findest du alle <br /> <span>Klassen im Detail</span>
//             </h1>

//             {/* Обработка состояний загрузки и ошибок */}
//             {loadingKlassen && <p>Загрузка классов...</p>}
//             {errorKlassen && <p>{errorKlassen}</p>}

//             {/* Отображение категорий и их классов */}
//             {!loadingKlassen && !errorKlassen && (
//                 <div>
//                     {Object.keys(groupedKlassen).map((category) => (
//                         <div key={category} className="classWrap">
//                             <h2>{category}</h2>
//                             <div className="cards3">
//                                 {groupedKlassen[category].map((klasse) => (
//                                     <div key={klasse.id} className="card-wrapper3">
//                                         <div className="card3">
//                                             {/* Отображение иконки */}

//                                             <p>{klasse.Name}
//                                                 <br />
//                                                <span style={{color:"black", fontWeight: "400", fontSize:"0.875rem"}}>
//                                                {klasse.icon_text}
//                                                </span> 
//                                             </p>
//                                             {/* Отображение категории (если нужно) */}
//                                             {/* Можно убрать, так как уже сгруппировано */}
//                                             {/* {klasse.Kategorie && klasse.Kategorie.Name && <p>{klasse.Kategorie.Name}</p>} */}
//                                             {/* Отображение описания */}
//                                             {/* {klasse.Beschreibung && (
//                                                 <div
//                                                     className="klasse-beschreibung"
//                                                     dangerouslySetInnerHTML={{ __html: klasse.Beschreibung }}
//                                                 />
//                                             )} */}
//                                             {klasse.Icon && klasse.Icon.filename_disk ? (
//                                                 <img
//                                                     src={getIconUrl(klasse.Icon)}
//                                                     alt={klasse.Name}
//                                                     className="klasse-icon"
//                                                     loading="lazy" // Ленивая загрузка изображений
//                                                 />
//                                             ) : (
//                                                 <div className="klasse-icon-placeholder">No Icon</div>
//                                             )}
//                                         </div>
//                                     </div>
//                                 ))}
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Class;







// src/components/Class.js

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Link } from 'react-router-dom'; // Импортируем Link
// import "../styles/Class.css";
// import Loader from "../components/Loader"

// const Class = () => {
//     // Состояния для данных из API /items/klassen
//     const [klassen, setKlassen] = useState([]);
//     const [loadingKlassen, setLoadingKlassen] = useState(true);
//     const [errorKlassen, setErrorKlassen] = useState(null);

//     // URL вашего API
//     const KLASSEN_API_URL = process.env.REACT_APP_API_BASE_URL + '/items/Klassen?fields=*.*.*';

//     useEffect(() => {
//         const fetchKlassen = async () => {
//             try {
//                 const response = await axios.get(KLASSEN_API_URL);
//                 if (response.data && response.data.data) {
//                     setKlassen(response.data.data);
//                 } else {
//                     setErrorKlassen('keine Data');
//                 }
//             } catch (error) {
//                 setErrorKlassen('Error');
//                 console.error(error);
//             } finally {
//                 setLoadingKlassen(false);
//             }
//         };

//         fetchKlassen();
//     }, []);

//     // Функция для формирования URL иконки
//     const getIconUrl = (icon) => {
//         if (!icon || !icon.filename_disk) return null;
//         // Поскольку доступ по /files/ возвращает 403, используем /assets/
//         const baseUrl = process.env.REACT_APP_API_BASE_URL + '/assets/';
//         return `${baseUrl}${icon.filename_disk}`;
//     };

//     // Функция для группировки классов по категориям
//     const groupByCategory = (klassen) => {
//         return klassen.reduce((acc, klasse) => {
//             const categoryName = klasse.Kategorie?.Name || "Keine Kategorie";
//             if (!acc[categoryName]) {
//                 acc[categoryName] = [];
//             }
//             acc[categoryName].push(klasse);
//             return acc;
//         }, {});
//     };

//     // Сгруппированные данные
//     const groupedKlassen = groupByCategory(klassen);

//     return (
//         <div className="class">
//             <h1 className="title">
//                 Hier findest du alle <br /> <span>Klassen im Detail</span>
//             </h1>

//             {/* Обработка состояний загрузки и ошибок */}
//             {loadingKlassen && <Loader/>}
//             {errorKlassen && <p>{errorKlassen}</p>}

//             {/* Отображение категорий и их классов */}
//             {!loadingKlassen && !errorKlassen && (
//                 <div>
//                     {Object.keys(groupedKlassen).map((category) => (
//                         <div key={category} className="classWrap">
//                             <h2>{category}</h2>
//                             <div className="cards3">
//                                 {groupedKlassen[category].map((klasse) => (
//                                     <Link to={`/details/${klasse.id}`} key={klasse.id} className="card-link">
//                                         <div className="card-wrapper3">
//                                             <div className="card3">
//                                                 {/* Отображение иконки */}
//                                                 {klasse.Icon && klasse.Icon.filename_disk ? (
//                                                     <img
//                                                         src={getIconUrl(klasse.Icon)}
//                                                         alt={klasse.Name}
//                                                         className="klasse-icon"
//                                                         loading="lazy"
//                                                         onError={(e) => {
//                                                             e.target.onerror = null;
//                                                             e.target.src = "/images/placeholder.png"; // Убедитесь, что этот файл существует
//                                                         }}
//                                                     />
//                                                 ) : (
//                                                     <div className="klasse-icon-placeholder">No Icon</div>
//                                                 )}
//                                                 <p>
//                                                     {klasse.Name}
//                                                     <br />
//                                                     <span style={{ color: "black", fontWeight: "400", fontSize: "0.875rem" }}>
//                                                         {klasse.icon_text}
//                                                     </span>
//                                                 </p>
//                                             </div>
//                                         </div>
//                                     </Link>
//                                 ))}
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Class;


// import React, { useContext } from "react";
// import { Link } from 'react-router-dom';
// import "../styles/Class.css";
// import Loader from "../components/Loader"
// import { ClassContext } from '../contexts/ClassContext';

// const Class = () => {
//     const { klassen, loadingKlassen, errorKlassen } = useContext(ClassContext);

//     // Функция для формирования URL иконки
//     const getIconUrl = (icon) => {
//         if (!icon || !icon.filename_disk) return null;
//         const baseUrl = process.env.REACT_APP_API_BASE_URL + '/assets/';
//         return `${baseUrl}${icon.filename_disk}`;
//     };

//     // Функция для группировки классов по категориям
//     const groupByCategory = (klassen) => {
//         return klassen.reduce((acc, klasse) => {
//             const categoryName = klasse.Kategorie?.Name || "Keine Kategorie";
//             if (!acc[categoryName]) {
//                 acc[categoryName] = [];
//             }
//             acc[categoryName].push(klasse);
//             return acc;
//         }, {});
//     };

//     // Сгруппированные данные
//     const groupedKlassen = groupByCategory(klassen);

//     if (loadingKlassen) {
//         return <Loader />;
//     }

//     if (errorKlassen) {
//         return <p className="error">{errorKlassen}</p>;
//     }

//     return (
//         <div className="class">
//             <h1 className="title">
//                 Hier findest du alle <br /> <span>Klassen im Detail</span>
//             </h1>

//             {/* Отображение категорий и их классов */}
//             {!loadingKlassen && !errorKlassen && (
//                 <div>
//                     {Object.keys(groupedKlassen).map((category) => (
//                         <div key={category} className="classWrap">
//                             <h2>{category}</h2>
//                             <div className="cards3">
//                                 {groupedKlassen[category].map((klasse) => (
//                                     <Link to={`/details/${klasse.id}`} key={klasse.id} className="card-link">
//                                         <div className="card-wrapper3">
//                                             <div className="card3">
//                                                 {/* Отображение иконки */}
//                                                 {klasse.Icon && klasse.Icon.filename_disk ? (
//                                                     <img
//                                                         src={getIconUrl(klasse.Icon)}
//                                                         alt={klasse.Name}
//                                                         className="klasse-icon"
//                                                         loading="lazy"
//                                                         onError={(e) => {
//                                                             e.target.onerror = null;
//                                                             e.target.src = "/images/placeholder.png";
//                                                         }}
//                                                     />
//                                                 ) : (
//                                                     <div className="klasse-icon-placeholder">No Icon</div>
//                                                 )}
//                                                 <p>
//                                                     {klasse.Name}
//                                                     <br />
//                                                     <span style={{ color: "black", fontWeight: "400", fontSize: "0.875rem" }}>
//                                                         {klasse.icon_text}
//                                                     </span>
//                                                 </p>
//                                             </div>
//                                         </div>
//                                     </Link>
//                                 ))}
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Class;


// src/components/Class.jsx

// import React, { useContext } from "react";
// import { Link } from 'react-router-dom';
// import "../styles/Class.css";
// import { ClassContext } from '../contexts/ClassContext';


// const Class = () => {
//     const { klassen, loadingKlassen, errorKlassen } = useContext(ClassContext);

//     // Функция для формирования URL иконки
//     const getIconUrl = (icon) => {
//         if (!icon || !icon.filename_disk) return null;
//         const baseUrl = process.env.REACT_APP_API_BASE_URL + '/assets/';
//         return `${baseUrl}${icon.filename_disk}`;
//     };

//     // Функция для группировки классов по категориям
//     const groupByCategory = (klassen) => {
//         return klassen.reduce((acc, klasse) => {
//             const categoryName = klasse.Kategorie?.Name || "Keine Kategorie";
//             if (!acc[categoryName]) {
//                 acc[categoryName] = [];
//             }
//             acc[categoryName].push(klasse);
//             return acc;
//         }, {});
//     };

//     // Сгруппированные данные
//     const groupedKlassen = groupByCategory(klassen);

//     if (loadingKlassen) {
//         // Возвращаем null, так как глобальный лоадер уже отображается
//         return null;
//     }

//     if (errorKlassen) {
//         return <p className="error">{errorKlassen}</p>;
//     }

//     return (
//         <div className="class">
//             <h1 className="title">
//                 Hier findest du alle <br /> <span>Klassen im Detail</span>
//             </h1>

//             {/* Отображение категорий и их классов */}
//             {!loadingKlassen && !errorKlassen && (
//                 <div>
//                     {Object.keys(groupedKlassen).map((category) => {
//                         // Разделяем классы внутри категории на три группы
//                         const standardClasses = groupedKlassen[category].filter(klasse => klasse.Unterkategorie === 'none');
//                         const zusatzClasses = groupedKlassen[category].filter(klasse => klasse.Unterkategorie === 'zusatz');
//                         const anhaengerClasses = groupedKlassen[category].filter(klasse => klasse.Unterkategorie === 'anhaenger');

//                         return (
//                             <div key={category} className="classWrap">
//                                 <h2 className="class-title">{category}</h2>

//                                 {/* Отображение стандартных классов */}
//                                 <div className="cards3">
//                                     {standardClasses.map((klasse) => (
//                                         <Link to={`/details/${klasse.id}`} key={klasse.id} className="card-link">
//                                             <div className="card-wrapper3">
//                                                 <div className="card3">
//                                                     {/* Отображение иконки */}
//                                                     {klasse.Icon && klasse.Icon.filename_disk ? (
//                                                         <img
//                                                             src={getIconUrl(klasse.Icon)}
//                                                             alt={klasse.Name}
//                                                             className="klasse-icon"
//                                                             loading="lazy"
//                                                             onError={(e) => {
//                                                                 e.target.onerror = null;
//                                                                 e.target.src = "/images/placeholder.png";
//                                                             }}
//                                                         />
//                                                     ) : (
//                                                         <div className="klasse-icon-placeholder">No Icon</div>
//                                                     )}
//                                                     <p>
//                                                         {klasse.Name}
//                                                         {/* <br /> */}

//                                                     </p>
//                                                     <p style={{ color: "black", fontWeight: "400", fontSize: "0.875rem" }}>
//                                                             {klasse.icon_text}
//                                                         </p>
//                                                 </div>
//                                             </div>
//                                         </Link>
//                                     ))}
//                                 </div>

//                                 {/* Отображение Zusatzausbildungen, если они есть */}
//                                 {zusatzClasses.length > 0 && (
//                                     <div className="zusatz-section">
//                                         <h2 className="zusatz-anhaenger-class">Zusatzausbildungen</h2>
//                                         <div className="cards3">
//                                             {zusatzClasses.map((klasse) => (
//                                                 <Link to={`/details/${klasse.id}`} key={klasse.id} className="card-link">
//                                                     <div className="card-wrapper3">
//                                                         <div className="card3">
//                                                             {/* Отображение иконки */}
//                                                             {klasse.Icon && klasse.Icon.filename_disk ? (
//                                                                 <img
//                                                                     src={getIconUrl(klasse.Icon)}
//                                                                     alt={klasse.Name}
//                                                                     className="klasse-icon"
//                                                                     loading="lazy"
//                                                                     onError={(e) => {
//                                                                         e.target.onerror = null;
//                                                                         e.target.src = "/images/placeholder.png";
//                                                                     }}
//                                                                 />
//                                                             ) : (
//                                                                 <div className="klasse-icon-placeholder">No Icon</div>
//                                                             )}
//                                                             <p>
//                                                                 {klasse.Name}
//                                                                 <br />
//                                                                 <span style={{ color: "black", fontWeight: "400", fontSize: "0.875rem" }}>
//                                                                     {klasse.icon_text}
//                                                                 </span>
//                                                             </p>
//                                                         </div>
//                                                     </div>
//                                                 </Link>
//                                             ))}
//                                         </div>
//                                     </div>
//                                 )}

//                                 {/* Отображение Anhänger, если они есть */}
//                                 {anhaengerClasses.length > 0 && (
//                                     <div className="anhaenger-section">
//                                         <h2 className="zusatz-anhaenger-class">Anhänger</h2>
//                                         <div className="cards3">
//                                             {anhaengerClasses.map((klasse) => (
//                                                 <Link to={`/details/${klasse.id}`} key={klasse.id} className="card-link">
//                                                     <div className="card-wrapper3">
//                                                         <div className="card3">
//                                                             {/* Отображение иконки */}
//                                                             {klasse.Icon && klasse.Icon.filename_disk ? (
//                                                                 <img
//                                                                     src={getIconUrl(klasse.Icon)}
//                                                                     alt={klasse.Name}
//                                                                     className="klasse-icon"
//                                                                     loading="lazy"
//                                                                     onError={(e) => {
//                                                                         e.target.onerror = null;
//                                                                         e.target.src = "/images/placeholder.png";
//                                                                     }}
//                                                                 />
//                                                             ) : (
//                                                                 <div className="klasse-icon-placeholder">No Icon</div>
//                                                             )}
//                                                             <p>
//                                                                 {klasse.Name}
//                                                                 <br />
//                                                                 <span style={{ color: "black", fontWeight: "400", fontSize: "0.875rem" }}>
//                                                                     {klasse.icon_text}
//                                                                 </span>
//                                                             </p>
//                                                         </div>
//                                                     </div>
//                                                 </Link>
//                                             ))}
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                         );
//                     })}
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Class;



// src/components/Class.jsx

import React, { useContext, useState, useRef, useEffect } from "react";
import { Link, useParams, useNavigate, useLocation } from 'react-router-dom';
import "../styles/Class.css";
import styles from "../styles/Class.module.css";
import { CategoryContext } from '../contexts/CategoryContext';
import { ClassContext } from '../contexts/ClassContext';
import InlineSvg from "./InlineSvg";

const Class = () => {
    const { cat } = useParams();
    const { kategorien, loadingKategorien, errorKategorien } = useContext(CategoryContext);
    const { klassen, loadingKlassen, errorKlassen } = useContext(ClassContext);

    const navigate = useNavigate(); // useNavigate

    const location = useLocation();
    const { pathname } = location;

    const [activeSection, setActiveSection] = useState((cat) ? cat : null);
    const [activeLeftOffset, setActiveLeftOffset] = useState(-100);
    const [activeWidth, setActiveWidth] = useState(0);
    const sections = useRef([]);

    const handleScroll = () => {
        const pageYOffset = window.scrollY;
        let newActiveSection = null;
        let newActiveNav = document.querySelectorAll('[data-active="true"]')[0];

        sections.current = document.querySelectorAll('[data-section]');

        sections.current.forEach((section) => {
            const sectionOffsetTop = section.offsetTop;
            const sectionHeight = section.offsetHeight;

            if (pageYOffset >= (sectionOffsetTop - 420) && pageYOffset < (sectionOffsetTop - 420) + sectionHeight) {
                newActiveSection = section.id;
            }
        });

        /* isNotTop(pageYOffset > 0 ? true : false); */
        if (newActiveNav) {
            setActiveLeftOffset(newActiveNav.offsetLeft + 24);
            setActiveWidth(newActiveNav.clientWidth - 48);
        } else {
            setActiveLeftOffset(-100);
            setActiveWidth(0);
        }

        setActiveSection(newActiveSection);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);

            if (cat) {
                scrollToSection(cat);
            }
        };
    }, []);


    // Функция для формирования URL иконки / Funktion zur Erstellung der URL für das Icon
    const getIconUrl = (icon) => {
        if (!icon || !icon.filename_disk) return null;
        const baseUrl = process.env.REACT_APP_API_BASE_URL + '/assets/';
        return `${baseUrl}${icon.filename_disk}`;
    };

    // Функция для группировки классов по категориям
    // const groupByCategory = (klassen) => {
    //     return klassen.reduce((acc, klasse) => {
    //         const kategorien = klasse.Kategorien || [];
    //         kategorien.forEach((kategorieRelation) => {
    //             const categoryName = kategorieRelation.Kategorien_id?.Name || "Keine Kategorie";
    //             if (!acc[categoryName]) {
    //                 acc[categoryName] = [];
    //             }
    //             acc[categoryName].push(klasse);
    //         });
    //         return acc;
    //     }, {});
    // };

    const groupByCategory = (klassen) => {
        return klassen.reduce((acc, klasse) => {
            const kategorien = klasse.Kategorien || [];
            console.log(kategorien);
            kategorien
                .sort((a, b) => (a.Kategorien_id.sort ?? 0) - (b.Kategorien_id.sort ?? 0))
                .forEach((kategorieRelation) => {
                const categoryName = kategorieRelation.Kategorien_id?.Name || "Keine Kategorie";

                if(!kategorieRelation.Kategorien_id.Hauptkategorie) {
                    return;
                }

                if (!acc[categoryName]) {
                    acc[categoryName] = [];
                }
                acc[categoryName].push(klasse);
            });
            return acc;
        }, {});
    };

    // Сгруппированные данные / Gruppierte Daten
    const groupedKlassen = groupByCategory(klassen);

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    if (loadingKlassen) {
        return null; // Возвращаем null, так как глобальный лоадер уже отображается / Rückgabe von null, da der globale Loader bereits angezeigt wird
    }

    if (errorKlassen) {
        return <p className="error">{errorKlassen}</p>;
    }

    /* useEffect(() => {
        return () => {
            if (cat) {
                document.getElementById(cat).scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    }, []); */

    return (
        <div className={styles.class}>
            <header className={styles.container}>
                {/* {pathname === "/klassen" && (
                    <button onClick={() => navigate(-1)} className="back-button">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--white)"><path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z"/></svg>
                    </button>
                )} */}

                <h1 className={styles.title}>
                    Hier findest du alle <br /> <span>Führerscheinklassen im Detail</span>
                </h1>
                <p className={styles["class-copy"]}>Egal, ob du auf zwei Rädern den Fahrtwind genießen, mit dem Auto die Straßen erobern oder richtig große Maschinen bewegen willst – wir machen dich startklar.</p>
            </header>

            {!loadingKategorien && !errorKategorien && (
                <>
                    <nav className={styles["cat-nav"]}>
                        <div className={styles["cat-nav-container"]}>
                            {console.log(kategorien)}
                            {kategorien
                                .filter(cat => cat.Hauptkategorie === true)
                                .map((category) => {
                                console.log(category);
                                return (
                                    <button
                                        key={category.id}
                                        type="button"
                                        className={(activeSection === category.Name.toLowerCase()) ? styles.active : ''}
                                        data-active={(activeSection === category.Name.toLowerCase()) ? 'true' : 'false'}
                                        onClick={() => scrollToSection(category.Name.toLowerCase())}>
                                        {category.Name}
                                    </button>
                                )
                            })}
                            <div className={styles["cat-nav-slider"]} style={{left: `${activeLeftOffset}px`, width: `${activeWidth}px`}}></div>
                        </div>
                    </nav>
                    <main>
                        {kategorien
                            .filter((kat) => kat.Hauptkategorie === true)
                            .map((category) => {
                            // Разделяем классы внутри категории на три группы / Aufteilen der Klassen innerhalb einer Kategorie in drei Gruppen
                            /* const standardClasses = groupedKlassen[category].filter(klasse => klasse.Unterkategorie === 'none');
                            const zusatzClasses = groupedKlassen[category].filter(klasse => klasse.Unterkategorie === 'zusatz');
                            const bkfClasses = groupedKlassen[category].filter(klasse => klasse.Unterkategorie === 'bkf');
                            const anhaengerClasses = groupedKlassen[category].filter(klasse => klasse.Unterkategorie === 'anhaenger'); */

                            /* if(category.Hauptkategorie) { */
                                /* console.log(category); */

                            return (
                                <section key={category.id} className={styles.classWrap} id={category.Name.toLowerCase()} data-section>
                                    <div className={styles['haupt-section']}>
                                        <div className={styles['class-section-container']}>
                                            <hgroup className={styles['class-title']}>
                                                <h2>{category.Name}</h2>
                                                {category.Beschreibung && (
                                                    <p>{category.Beschreibung}</p>
                                                )}
                                            </hgroup>

                                            {/* Отображение стандартных классов / Anzeige der Standardklassen */}
                                            {klassen.length > 0 && (
                                                <div className={styles.cards3}>
                                                    {klassen
                                                    /* .filter(klasse => klasse.Kategorien.Kategorien_id.id === category.id) */
                                                    .filter(klasse => klasse.Kategorien.find(kat => kat.Kategorien_id.id === category.id))
                                                    .map((klasse) => (
                                                        <Link to={`/klassen/${category.Name.toLowerCase()}/${klasse.slug}`} key={klasse.id} className={`${styles.card3} ${styles['card-link']}`}>
                                                            {/* Отображение иконки / Anzeige des Icons */}
                                                            <hgroup>
                                                                <div>
                                                                    {klasse.Icon && klasse.Icon.filename_disk ? (
                                                                        <div className={styles['klasse-icon']}>
                                                                            { getIconUrl(klasse.Icon).endsWith('.svga') ? (
                                                                                <InlineSvg
                                                                                    src={getIconUrl(klasse.Icon)}
                                                                                    alt={klasse.Name}
                                                                                    loading="lazy"
                                                                                    onError={(e) => {
                                                                                        e.target.onerror = null;
                                                                                        e.target.src = "/images/placeholder.png";
                                                                                    }}
                                                                                />
                                                                            ) : (
                                                                                <img
                                                                                    src={getIconUrl(klasse.Icon)}
                                                                                    alt={klasse.Name}
                                                                                    loading="lazy"
                                                                                    onError={(e) => {
                                                                                        e.target.onerror = null;
                                                                                        e.target.src = "/images/placeholder.png";
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        </div>
                                                                    ) : (
                                                                        <div>No Icon</div>
                                                                    )}
                                                                    { klasse.Klassenkuerzel ? <h3>{klasse.Klassenkuerzel}</h3> : ''}
                                                                </div>
                                                                { klasse.Untertitel ? <p>{klasse.Untertitel}</p> : ''}
                                                            </hgroup>
                                                            <p>{klasse.icon_text}</p>
                                                        </Link>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>


                                    {/* Отображение Zusatzausbildungen, если они есть / Anzeige der Zusatzausbildungen, falls vorhanden */}
                                    {klassen
                                        .filter(klasse => category.Zusatzausbildungen?.find(klid => klid.Klassen_id === klasse.id))
                                        .length > 0 && (
                                        <div className={styles['zusatz-section']}>
                                            <div className={styles['class-section-container']}>
                                                <h3 className={styles['zusatz-anhaenger-class']}>Zusatzausbildungen</h3>
                                                <div className={styles.cards3}>
                                                    {klassen
                                                        .filter(klasse => category.Zusatzausbildungen?.find(klid => klid.Klassen_id === klasse.id))
                                                        .map((klasse) => (
                                                        <Link to={`/klassen/${category.Name.toLowerCase()}/${klasse.slug}`} key={klasse.id} className={`${styles.card3} ${styles['card-link']}`}>
                                                            {/* Отображение иконки / Anzeige des Icons */}
                                                            <hgroup>
                                                                <div>
                                                                    {klasse.Icon && klasse.Icon.filename_disk ? (
                                                                        <div className={styles['klasse-icon']}>
                                                                            { getIconUrl(klasse.Icon).endsWith('.svga') ? (
                                                                                <InlineSvg
                                                                                    src={getIconUrl(klasse.Icon)}
                                                                                    alt={klasse.Name}
                                                                                    loading="lazy"
                                                                                    onError={(e) => {
                                                                                        e.target.onerror = null;
                                                                                        e.target.src = "/images/placeholder.png";
                                                                                    }}
                                                                                />
                                                                            ) : (
                                                                                <img
                                                                                    src={getIconUrl(klasse.Icon)}
                                                                                    alt={klasse.Name}
                                                                                    loading="lazy"
                                                                                    onError={(e) => {
                                                                                        e.target.onerror = null;
                                                                                        e.target.src = "/images/placeholder.png";
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        </div>
                                                                    ) : (
                                                                        <div>No Icon</div>
                                                                    )}
                                                                    { klasse.Klassenkuerzel ? <h3>{klasse.Klassenkuerzel}</h3> : ''}
                                                                </div>
                                                                { klasse.Untertitel ? <p>{klasse.Untertitel}</p> : ''}
                                                            </hgroup>
                                                            <p>{klasse.icon_text}</p>
                                                        </Link>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* Отображение Zusatzausbildungen, если они есть / Anzeige der Zusatzausbildungen, falls vorhanden */}
                                    {klassen.length < 0 && (
                                        <div className={styles['zusatz-section']}>
                                            <div className={styles['class-section-container']}>
                                                <h3 className={styles['zusatz-anhaenger-class']}>Berufskraftfahrer-Ausbildungen</h3>
                                                <div className={styles.cards3}>
                                                    {klassen.map((klasse) => (
                                                        <Link to={`/klassen/${category.Name.toLowerCase()}/${klasse.id}`} key={klasse.id} className={`${styles.card3} ${styles['card-link']}`}>
                                                            {/* Отображение иконки / Anzeige des Icons */}
                                                            <hgroup>
                                                                <div>
                                                                    {klasse.Icon && klasse.Icon.filename_disk ? (
                                                                        <div className={styles['klasse-icon']}>
                                                                            <img
                                                                                src={getIconUrl(klasse.Icon)}
                                                                                alt={klasse.Name}
                                                                                loading="lazy"
                                                                                onError={(e) => {
                                                                                    e.target.onerror = null;
                                                                                    e.target.src = "/images/placeholder.png";
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    ) : (
                                                                        <div>No Icon</div>
                                                                    )}
                                                                    { klasse.Klassenkuerzel ? <h3>{klasse.Klassenkuerzel}</h3> : ''}
                                                                </div>
                                                                { klasse.Untertitel ? <p>{klasse.Untertitel}</p> : ''}
                                                            </hgroup>
                                                            <p>{klasse.icon_text}</p>
                                                        </Link>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* Отображение Anhänger, если они есть / Anzeige von Anhänger, falls vorhanden */}
                                    {klassen.length < 0 && (
                                        <div className={styles['anhaenger-section']}>
                                            <div className={styles['class-section-container']}>
                                                <h3 className={styles['zusatz-anhaenger-class']}>Anhänger</h3>
                                                <div className={styles.cards3}>
                                                    {klassen.map((klasse) => (
                                                        <Link to={`/klassen/${category.Name.toLowerCase()}/${klasse.id}`} key={klasse.id} className={`${styles.card3} ${styles['card-link']}`}>
                                                            {/* Отображение иконки / Anzeige des Icons */}
                                                            <hgroup>
                                                                <div>
                                                                    {klasse.Icon && klasse.Icon.filename_disk ? (
                                                                        <div className={styles['klasse-icon']}>
                                                                            <img
                                                                                src={getIconUrl(klasse.Icon)}
                                                                                alt={klasse.Name}
                                                                                loading="lazy"
                                                                                onError={(e) => {
                                                                                    e.target.onerror = null;
                                                                                    e.target.src = "/images/placeholder.png";
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    ) : (
                                                                        <div>No Icon</div>
                                                                    )}
                                                                    { klasse.Klassenkuerzel ? <h3>{klasse.Klassenkuerzel}</h3> : ''}
                                                                </div>
                                                                { klasse.Untertitel ? <p>{klasse.Untertitel}</p> : ''}
                                                            </hgroup>
                                                            <p>{klasse.icon_text}</p>
                                                        </Link>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </section>
                            );
                        })}
                    </main>
                </>
            )}

            {/* Отображение категорий и их классов / Anzeige der Kategorien und ihrer Klassen */}
            {/* {!loadingKlassen && !errorKlassen && (
                <>
                    <nav className={styles["cat-nav"]}>
                        <div className={styles["cat-nav-container"]}>
                            {console.log(groupedKlassen)}
                            {Object.keys(groupedKlassen)
                                .sort((a, b) => (a.sort ?? 0) - (b.sort ?? 0))
                                .map((category) => {
                                console.log(category);
                                return (
                                    <button
                                        key={category}
                                        type="button"
                                        className={(activeSection === category.toLowerCase()) ? styles.active : ''}
                                        onClick={() => scrollToSection(category.toLowerCase())}>
                                        {category}
                                    </button>
                                )
                            })}
                        </div>
                    </nav>
                <main>
                    {Object.keys(groupedKlassen).map((category) => {
                        // Разделяем классы внутри категории на три группы / Aufteilen der Klassen innerhalb einer Kategorie in drei Gruppen
                        const standardClasses = groupedKlassen[category].filter(klasse => klasse.Unterkategorie === 'none');
                        const zusatzClasses = groupedKlassen[category].filter(klasse => klasse.Unterkategorie === 'zusatz');
                        const bkfClasses = groupedKlassen[category].filter(klasse => klasse.Unterkategorie === 'bkf');
                        const anhaengerClasses = groupedKlassen[category].filter(klasse => klasse.Unterkategorie === 'anhaenger');

                        if(!category.Hauptkategorie) {

                            return (
                                <section key={category} className={styles.classWrap} id={category.toLowerCase()} data-section>
                                    <div className={styles['haupt-section']}>
                                        <div className={styles['class-section-container']}>
                                            <h2 className={styles['class-title']}>{category}</h2>

                                            {standardClasses.length > 0 && (
                                                <div className={styles.cards3}>
                                                    {standardClasses.map((klasse) => (
                                                        <Link to={`/klassen/${category.toLowerCase()}/${klasse.id}`} key={klasse.id} className={`${styles.card3} ${styles['card-link']}`}>
                                                            <hgroup>
                                                                <div>
                                                                    {klasse.Icon && klasse.Icon.filename_disk ? (
                                                                        <div className={styles['klasse-icon']}>
                                                                            <img
                                                                                src={getIconUrl(klasse.Icon)}
                                                                                alt={klasse.Name}
                                                                                loading="lazy"
                                                                                onError={(e) => {
                                                                                    e.target.onerror = null;
                                                                                    e.target.src = "/images/placeholder.png";
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    ) : (
                                                                        <div>No Icon</div>
                                                                    )}
                                                                    { klasse.Klassenkuerzel ? <h3>{klasse.Klassenkuerzel}</h3> : ''}
                                                                </div>
                                                                { klasse.Untertitel ? <p>{klasse.Untertitel}</p> : ''}
                                                            </hgroup>
                                                            <p>{klasse.icon_text}</p>
                                                        </Link>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>


                                    {zusatzClasses.length > 0 && (
                                        <div className={styles['zusatz-section']}>
                                            <div className={styles['class-section-container']}>
                                                <h3 className={styles['zusatz-anhaenger-class']}>Zusatzausbildungen</h3>
                                                <div className={styles.cards3}>
                                                    {zusatzClasses.map((klasse) => (
                                                        <Link to={`/klassen/${category.toLowerCase()}/${klasse.id}`} key={klasse.id} className={`${styles.card3} ${styles['card-link']}`}>
                                                            <hgroup>
                                                                <div>
                                                                    {klasse.Icon && klasse.Icon.filename_disk ? (
                                                                        <div className={styles['klasse-icon']}>
                                                                            <img
                                                                                src={getIconUrl(klasse.Icon)}
                                                                                alt={klasse.Name}
                                                                                loading="lazy"
                                                                                onError={(e) => {
                                                                                    e.target.onerror = null;
                                                                                    e.target.src = "/images/placeholder.png";
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    ) : (
                                                                        <div>No Icon</div>
                                                                    )}
                                                                    { klasse.Klassenkuerzel ? <h3>{klasse.Klassenkuerzel}</h3> : ''}
                                                                </div>
                                                                { klasse.Untertitel ? <p>{klasse.Untertitel}</p> : ''}
                                                            </hgroup>
                                                            <p>{klasse.icon_text}</p>
                                                        </Link>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {bkfClasses.length > 0 && (
                                        <div className={styles['zusatz-section']}>
                                            <div className={styles['class-section-container']}>
                                                <h3 className={styles['zusatz-anhaenger-class']}>Berufskraftfahrer-Ausbildungen</h3>
                                                <div className={styles.cards3}>
                                                    {bkfClasses.map((klasse) => (
                                                        <Link to={`/klassen/${category.toLowerCase()}/${klasse.id}`} key={klasse.id} className={`${styles.card3} ${styles['card-link']}`}>
                                                            <hgroup>
                                                                <div>
                                                                    {klasse.Icon && klasse.Icon.filename_disk ? (
                                                                        <div className={styles['klasse-icon']}>
                                                                            <img
                                                                                src={getIconUrl(klasse.Icon)}
                                                                                alt={klasse.Name}
                                                                                loading="lazy"
                                                                                onError={(e) => {
                                                                                    e.target.onerror = null;
                                                                                    e.target.src = "/images/placeholder.png";
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    ) : (
                                                                        <div>No Icon</div>
                                                                    )}
                                                                    { klasse.Klassenkuerzel ? <h3>{klasse.Klassenkuerzel}</h3> : ''}
                                                                </div>
                                                                { klasse.Untertitel ? <p>{klasse.Untertitel}</p> : ''}
                                                            </hgroup>
                                                            <p>{klasse.icon_text}</p>
                                                        </Link>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {anhaengerClasses.length > 0 && (
                                        <div className={styles['anhaenger-section']}>
                                            <div className={styles['class-section-container']}>
                                                <h3 className={styles['zusatz-anhaenger-class']}>Anhänger</h3>
                                                <div className={styles.cards3}>
                                                    {anhaengerClasses.map((klasse) => (
                                                        <Link to={`/klassen/${category.toLowerCase()}/${klasse.id}`} key={klasse.id} className={`${styles.card3} ${styles['card-link']}`}>
                                                            <hgroup>
                                                                <div>
                                                                    {klasse.Icon && klasse.Icon.filename_disk ? (
                                                                        <div className={styles['klasse-icon']}>
                                                                            <img
                                                                                src={getIconUrl(klasse.Icon)}
                                                                                alt={klasse.Name}
                                                                                loading="lazy"
                                                                                onError={(e) => {
                                                                                    e.target.onerror = null;
                                                                                    e.target.src = "/images/placeholder.png";
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    ) : (
                                                                        <div>No Icon</div>
                                                                    )}
                                                                    { klasse.Klassenkuerzel ? <h3>{klasse.Klassenkuerzel}</h3> : ''}
                                                                </div>
                                                                { klasse.Untertitel ? <p>{klasse.Untertitel}</p> : ''}
                                                            </hgroup>
                                                            <p>{klasse.icon_text}</p>
                                                        </Link>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </section>
                            );
                        }
                    })}
                </main>
                </>
            )} */}
        </div>
    );
};

export default Class;
